"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseLeaseToOwnData = exports.LeaseToOwnDataContextProvider = exports.LeaseToOwnDataContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LeaseToOwnDataContext = exports.LeaseToOwnDataContext = /*#__PURE__*/_react.default.createContext();
const parseLeaseToOwnData = exactMatchDomain => {
  const leaseToOwnOptions = exactMatchDomain?.LeaseToOwnOptions;
  const paymentTerm = leaseToOwnOptions?.PaymentTerm;
  const maxPayments = leaseToOwnOptions?.MaxPayments;
  const minPayments = leaseToOwnOptions?.MinPayments;
  const defaultPayments = leaseToOwnOptions?.DefaultPayments;
  const installmentLengthAndPrices = leaseToOwnOptions?.PaymentOptions.reduce((paymentOptions, option) => {
    paymentOptions[option.NumPayments] = option.PaymentPriceDisplay;
    return paymentOptions;
  }, {});
  return {
    paymentTerm,
    installmentLengthAndPrices,
    maxPayments,
    minPayments,
    defaultPayments
  };
};
exports.parseLeaseToOwnData = parseLeaseToOwnData;
const LeaseToOwnDataContextProvider = ({
  children,
  availableDomain,
  leaseToOwnFeatureData,
  ltoInCart = {},
  ...props
}) => {
  const {
    paymentTerm,
    installmentLengthAndPrices,
    maxPayments,
    minPayments,
    defaultPayments
  } = parseLeaseToOwnData(availableDomain);
  const {
    defaultTermLengthOverride
  } = leaseToOwnFeatureData?.data || {};
  const defaultTermLength = ltoInCart.paymentTerm || defaultPayments;
  const termLength = installmentLengthAndPrices[defaultTermLengthOverride] ? defaultTermLengthOverride : defaultTermLength;
  const defaultPaymentsPrice = installmentLengthAndPrices[termLength];
  const [numPayments, setNumPayments] = (0, _react.useState)(termLength);
  const [paymentPrice, setPaymentPrice] = (0, _react.useState)(defaultPaymentsPrice);
  return /*#__PURE__*/_react.default.createElement(LeaseToOwnDataContext.Provider, {
    value: {
      numPayments,
      setNumPayments,
      paymentTerm,
      minPayments,
      maxPayments,
      paymentPrice,
      setPaymentPrice,
      installmentLengthAndPrices,
      ltoInCart
    }
  }, /*#__PURE__*/_react.default.cloneElement(children, {
    availableDomain,
    leaseToOwnFeatureData,
    ...props
  }));
};
exports.LeaseToOwnDataContextProvider = LeaseToOwnDataContextProvider;
LeaseToOwnDataContextProvider.propTypes = {
  children: _propTypes.default.node,
  availableDomain: _propTypes.default.object,
  leaseToOwnFeatureData: _propTypes.default.shape({
    data: _propTypes.default.shape({
      learnMoreText: _propTypes.default.string,
      tooltipContent: _propTypes.default.string,
      serviceFees: _propTypes.default.arrayOf(_propTypes.default.shape({
        minValueRange: _propTypes.default.number,
        maxValueRange: _propTypes.default.number,
        percentage: _propTypes.default.number
      })),
      defaultTermLengthOverride: _propTypes.default.number
    })
  }),
  ltoInCart: _propTypes.default.shape({
    paymentTerm: _propTypes.default.number
  })
};